export default __webpack_public_path__ + "static/media/logoGestor.c5a22032.png";